export default {
  state: {
    app: '',
  },
  getters: {
    app: (state: any) => {
      return state.app || '';
    },
  },
  mutations: {
    updateApp: (state: any, app: any) => {
      state.app = app || '';
    },
  },
};
